//fix
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Button, InputGroup, InputGroupText, Input, Col, CardBody, Card, Row } from "reactstrap";
import './Order.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAlt, faBicycle, faWalking, faMapMarkerAlt, faCheckCircle, faShoppingBasket, faEnvelope, faSearch, faTruck, faFire, faClipboardList, faClock, faPhone, faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import DiscountCouponService from "../DiscountCoupon/Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import PermissionAccess from '../../PermissionAccess/Access.js';
import { getFileUrl } from "../../utils/fileUtils";
import Alerts from "../../components/Alerts/alerts";

const OrderDetails = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState('details');
    const { authData } = PermissionAccess();
    const [orderData, setOrderData] = useState(null);

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                const response = await DiscountCouponService.GetOrderDetails(authData.sessionID, id);
                if (response.data.message === "Unauthorized") {
                    AuthService.logout();
                    navigate("/login");
                    window.location.reload();
                } else if (response.data) {
                    setOrderData(response.data.orderData[0]);
                }
            } catch (error) {
                console.error("Error fetching order details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrderDetails();
    }, [id, authData.sessionID, navigate]);

    const formatStatus = (status) => {
        if (!status) return '';

        // Replace underscores with spaces and capitalize each word
        return status
            .toLowerCase() // Ensure all letters are lowercase
            .split('_')    // Split by underscores
            .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
            .join(' ');    // Join the words with spaces
    };

    const renderTrackingContentDEMO = () => {
        if (!orderData || !orderData?.orderTrackingDetails || orderData?.orderTrackingDetails.length === 0) {
            return <div>No tracking information available</div>;
        }

        return (
            <div style={{
                backgroundColor: 'white',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}>
                {orderData?.orderTrackingDetails.map((step, index) => (
                    <div key={index} style={{
                        display: 'flex',
                        marginBottom: '20px',
                        position: 'relative'
                    }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: '#e74c3c',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '20px',
                            zIndex: 1
                        }}>
                            <FontAwesomeIcon icon={getIconForStatus(step.status)} style={{ color: 'white' }} />
                        </div>
                        {index !== orderData?.orderTrackingDetails.length - 1 && (
                            <div style={{
                                position: 'absolute',
                                left: '20px',
                                top: '40px',
                                bottom: '-20px',
                                width: '2px',
                                borderLeft: '2px dashed #e74c3c',
                                zIndex: 0
                            }} />
                        )}
                        <div style={{ flex: 1 }}>
                            <h3 style={{ margin: '0 0 5px 0', color: '#333' }}>{formatStatus(step.status)}</h3>
                            <p style={{ margin: '0', color: '#e74c3c' }}>
                                <FontAwesomeIcon icon={faClock} style={{ marginRight: '5px' }} />
                                {step.date}
                                {/* {moment(step.date).format('MMMM Do YYYY, h:mm:ss a')} */}
                            </p>
                            {step.status === 'ON_GOING' && step.shareLink && (
                                <button style={{
                                    backgroundColor: 'white',
                                    border: '1px solid #e74c3c',
                                    color: '#e74c3c',
                                    borderRadius: '5px',
                                    padding: '5px 10px',
                                    marginTop: '10px',
                                    cursor: 'pointer'
                                }}
                                    onClick={() => { window.open(step.shareLink, '_blank', 'noopener,noreferrer') }}
                                >
                                    <FontAwesomeIcon icon={faBicycle} style={{ marginRight: '5px' }} />
                                    Track
                                </button>
                            )}
                            {step.driver && (
                                <div style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                    padding: '10px',
                                    marginTop: '10px'
                                }}>
                                    <p style={{ margin: '0 0 5px 0' }}><strong>Driver Name:</strong> {step.driver.name}</p>
                                    <p style={{ margin: '0 0 5px 0' }}>
                                        <strong>Driver Phone:</strong> {step.driver.phone}
                                        <button style={{
                                            backgroundColor: 'white',
                                            border: '1px solid #e74c3c',
                                            borderRadius: '5px',
                                            padding: '2px 5px',
                                            marginLeft: '10px',
                                            cursor: 'pointer'
                                        }}>
                                            <FontAwesomeIcon icon={faPhone} style={{ color: '#e74c3c' }} />
                                        </button>
                                    </p>
                                    {step.driver.plateNumber && <p style={{ margin: '0' }}><strong>Number Plate:</strong> {step.driver.plateNumber}</p>}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const getIconForStatus = (status) => {
        switch (status.toLowerCase()) {
            case 'delivered':
                return faCheckCircle;
            case 'picked by driver':
                return faShoppingBasket;
            case 'driver assigned':
                return faBicycle;
            case 'on going':
                return faFire;
            case 'assigning driver':
                return faSearch;
            case 'order received':
                return faClipboardList;
            default:
                return faClipboardList;
        }
    };

    const processOrder = async (e, status) => {
        e.preventDefault();
        const msg = status
            ? t("You want to place order with Lalamove")
            : t("You want to place order without Lalamove");
        Alerts.swalOKAlert(msg).then(async res => {
            if (res === true) {
                setLoading(true);
                const response = await DiscountCouponService.AdminProcessOrder(authData.sessionID, id, status);
                setLoading(false);
                if (response.data.status === true) {
                    Alerts.swalClickProceedAlert('Order Has Been Placed Successfully').then(res => {
                        if (res === true) {
                            window.location.reload();
                        }
                    });
                }
            }
        });
    };


    const cancelLalamove = async (e, status) => {
        e.preventDefault();
        const msg = t("You want to cancel order from Lalamove")
        Alerts.swalOKAlert(msg).then(async res => {
            if (res === true) {
                setLoading(true);
                const response = await DiscountCouponService.CancelLalamoveOrder(authData.sessionID, id);
                setLoading(false);
                if (response.data.status === true) {
                    Alerts.swalClickProceedAlert('Order Has Been Cancelled Successfully').then(res => {
                        if (res === true) {
                            window.location.reload();
                        }
                    });
                }
            }
        });
    };

    const [inputValue, setInputValue] = useState('');
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const applyTip = async () => {
        if (isNaN(parseFloat(inputValue)) || parseFloat(inputValue) <= parseFloat(orderData?.priorityTip)) {
            Alerts.swalErrorAlert(`The new tip must be greater than the previous tip ${orderData?.priorityTip}.`);
            return;
        }
        Alerts.swalOKAlert('You want to apply this tip?').then(async res => {
            if (res === true) {
                setLoading(true);
                const response = await DiscountCouponService.AdditionalTip(authData.sessionID, id, inputValue);
                setLoading(false);
                if (response.data.status === true) {
                    Alerts.swalClickProceedAlert('Tip Has Been Applied Successfully').then(res => {
                        if (res === true) {
                            window.location.reload();
                        }
                    });
                }
            }
        });
    };


    const [inputValueLink, setInputValueLink] = useState('');
    const handleInputLinkChange = (e) => {
        setInputValueLink(e.target.value);
    };

    const applyLink = async () => {
        if (isNaN(parseFloat(inputValueLink))) {
            Alerts.swalErrorAlert(`Lalamove ID required.`);
            return;
        }
        Alerts.swalOKAlert('You want to link this ID?').then(async res => {
            if (res === true) {
                setLoading(true);
                const response = await DiscountCouponService.LalamoveLinkID(authData.sessionID, id, inputValueLink);
                setLoading(false);
                if (response.data.status === true) {
                    Alerts.swalClickProceedAlert('Lalamove order id updated successfully').then(res => {
                        if (res === true) {
                            window.location.reload();
                        }
                    });
                }
            }
        });
    };


    const additionalTip = async (e, amount) => {
        e.preventDefault();

        Alerts.swalOKAlert('You want to apply this tip?').then(async res => {
            if (res === true) {
                setLoading(true);
                const response = await DiscountCouponService.AdditionalTip(authData.sessionID, id, amount);
                setLoading(false);
                if (response.data.status === true) {
                    Alerts.swalClickProceedAlert('Tip Has Been Applied Successfully').then(res => {
                        if (res === true) {
                            window.location.reload();
                        }
                    });
                }
            }
        });
    };




    const renderOrderHeader = () => (
        <Card className="mb-3">
            <CardBody>
                <Row>
                    <Col md="3">
                        <div className="order-number">
                            <FontAwesomeIcon icon={faClipboardList} className="text-danger icon-style me-2" />
                            <h6 className="card-title">Order Number</h6>
                            <p>{orderData?.order_number}</p><br />
                        </div>
                    </Col>
                    <Col md="3">
                        <div className="order-status">
                            <FontAwesomeIcon icon={faClock} className="text-danger icon-style me-2" />
                            <h6 className="card-title">Status</h6>
                            <p>{formatStatus(orderData?.status)}</p>
                        </div>
                    </Col>
                    <Col md="3">
                        <div className="order-delivery">
                            <FontAwesomeIcon icon={orderData?.deliveryMethod === 'delivery' ? faBicycle : faWalking} className="text-warning icon-style me-2" />
                            <h6 className="card-title">{orderData?.deliveryMethod === 'delivery' ? 'Delivery' : 'Self Pickup'}</h6>

                            {orderData?.late_status === true && orderData?.lalamove_orderID ? (
                                <>
                                    <p>Late</p>
                                </>
                            ) : (
                                <>
                                    <p>Normal</p>
                                </>
                            )}
                        </div>
                    </Col>

                    <Col md="3">
                        <div className="order-delivery">
                            <FontAwesomeIcon icon={faClock} className="text-warning icon-style me-2" />
                            <h6 className="card-title">Order placed at:</h6>
                            <p>{moment(orderData?.order_date).format('MMMM Do YYYY, h:mm:ss a')}</p>
                        </div>
                    </Col>

                    {orderData?.late_status === true && orderData?.lalamove_orderID && orderData?.status === 'confirmed' && (
                        <>
                            <Row>
                                <Col md="4">
                                    <div className="order-delivery">
                                        <FontAwesomeIcon icon={faMoneyBill} className="text-warning icon-style me-2" />
                                        <h6 className="card-title mt-3">Prioritize</h6>
                                        <InputGroup>
                                            <Input
                                                placeholder="Prioritize Amount"
                                                value={inputValue}
                                                onChange={handleInputChange}
                                            />
                                            <InputGroupText addonType="append">
                                                <Button color="dark" onClick={applyTip}>Apply</Button>
                                            </InputGroupText>
                                        </InputGroup>
                                    </div>
                                </Col>

                                <Col md="4">
                                    <div className="order-delivery">
                                        <ButtonGroup>
                                            {['1.00', '2.00', '3.00', '4.00', '10.00', '20.00'].map((value) => (
                                                <Button
                                                    key={value}
                                                    color="dark"
                                                    onClick={(e) => additionalTip(e, value)}
                                                    disabled={parseFloat(value) <= parseFloat(orderData?.priorityTip)}
                                                >
                                                    {value}
                                                </Button>
                                            ))}
                                        </ButtonGroup>
                                    </div>

                                </Col>

                            </Row>
                        </>
                    )}


                </Row>
            </CardBody>
        </Card>
    );

    const renderOrderDetails = () => (
        <Card className="mb-3">
            <CardBody>
                <h5 className="card-title">Order Details</h5>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th>Quantity</th>
                            <th>Price per item</th>
                            <th>Variations</th>
                            <th>Total Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderData?.cartDetails.map((product, index) => {
                            // Calculate total variation price
                            const totalVariationPrice = product.variations?.reduce((sum, variation) =>
                                sum + (parseFloat(variation.variation_price) || 0), 0) || 0;

                            // Calculate total price including variations
                            const totalPrice = (parseFloat(product.price_per_item) + totalVariationPrice) * product.quantity;

                            return (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>
                                            <img src={getFileUrl(product.item.item_image)} alt={product.item.item_name} className="product-image" style={{ width: '50px', height: '50px', marginRight: '10px' }} />
                                            <span>{product.item.item_name}</span>
                                        </td>
                                        <td>{product.quantity}</td>
                                        <td>RM {parseFloat(product.price_per_item).toFixed(2)}</td>
                                        <td>
                                            {product.variations && product.variations.length > 0 ? (
                                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                    {product.variations.map((variation, vIndex) => (
                                                        <li key={vIndex}>
                                                            {variation.variation_name}: {variation.variation_type_name} (RM {variation.variation_price.toFixed(2)})
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                "No variations"
                                            )}
                                        </td>
                                        <td>RM {totalPrice.toFixed(2)}</td>
                                    </tr>
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </CardBody>
        </Card>
    );

    const renderCustomerDetails = () => {
        const lat = orderData?.DistanceFormula?.stops?.[1]?.coordinates?.lat;
        const lng = orderData?.DistanceFormula?.stops?.[1]?.coordinates?.lng;
        const { location, unit, block } = orderData?.deliveryAddress || {};
        const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
        return (
            <Card className="mb-3" style={{ height: '295px' }}>
                <CardBody>
                    <h5 className="card-title">Customer Detail</h5>
                    <p><strong>Customer Name:</strong> {orderData?.userDetails[0].name}</p>
                    <p><strong>Customer Number:</strong> {orderData?.userDetails[0].phone}</p>
                    <p><strong>Customer Rating:</strong> {orderData?.userDetails[0].customer_rating}</p>
                    <p><strong>Business:</strong> {orderData?.businessDetails[0].name}</p>
                    {orderData?.deliveryMethod === 'delivery' && (
                        <>
                            <p>
                                <strong>Delivery Address:</strong> {`${location}, ${unit}, ${block}`}
                                <NavLink target="_blank" to={mapUrl} style={{ marginLeft: '10px' }}>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: 'red' }} />
                                </NavLink>
                            </p>
                        </>
                    )}
                </CardBody>
            </Card>
        );
    };

    const formatCurrency = (value) => {
        const parsedValue = parseFloat(value);
        return !isNaN(parsedValue)
            ? parsedValue.toFixed(2)
            : '0.00';
    };

    const renderOrderTotal = () => (
        <Card className="mb-3" style={{ height: '295px' }}>
            <CardBody>
                <h5 className="card-title">Order Total</h5>
                <Row>
                    <Col md="6">
                        <p><strong>Order Sub Total:</strong></p>
                        <p><strong>Delivery Charges:</strong></p>
                        <p><strong>Discount:</strong></p>
                        <p><strong>{orderData?.Calculations.sst_dynamic_label} ({orderData?.Calculations.sst_percentage}):</strong></p>
                        <p><strong>Grand Total:</strong></p>

                        {orderData?.deliveryMethod === 'delivery' && (
                            <>
                                <p style={{ color: 'red' }}><strong>Additional Priority/Delivery Fee by Seller:</strong></p>
                                <p><strong>Additional Delivery Fee by Customer:</strong></p>
                            </>
                        )}


                    </Col>
                    <Col md="6" className="text-end">
                        <p>RM {formatCurrency(orderData?.Calculations.subTotal)}</p>
                        <p>RM {formatCurrency(orderData?.Calculations.deliveryTipFee)}</p>
                        <p>RM {formatCurrency(orderData?.Calculations.discount)}</p>
                        <p>RM {formatCurrency(orderData?.Calculations.sst)}</p>
                        <p>RM {formatCurrency(orderData?.Calculations.grandTotal)}</p>
                        {orderData?.deliveryMethod === 'delivery' && (
                            <>
                                <p style={{ color: 'red' }}>RM {formatCurrency(orderData?.Calculations.additionalDeliveryFeeBySeller)}</p>
                                <p>RM {formatCurrency(orderData?.Calculations.additionalDeliveryFee)}</p>

                            </>
                        )}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );

    return (
        <div className="app-main__outer">
            <div className="app-main__inner">
                <LoadingOverlay active={loading} spinner={<DNALoader />}>
                    <div className="app-page-title">
                        <div className="page-title-wrapper">
                            <div className="page-title-heading">
                                <div className="page-title-icon">
                                    <FontAwesomeIcon icon={faClipboardList} className="icon-gradient bg-tempting-azure" />
                                </div>
                                <div>
                                    {t("Orders Management")}
                                    <div className="page-title-subheading">
                                        {t("Order Details & Tracking")}.
                                    </div>
                                </div>
                            </div>
                            <div className="page-title-actions">
                                <button onClick={() => navigate(-1)} type="button" className="btn btn-outline-success btn-hover-shine me-3">
                                    {t("Back")}
                                </button>
                            </div>
                        </div>
                    </div>

                    {renderOrderHeader()}

                    <div className="order-tabs mb-3">
                        <button
                            style={{
                                background: activeTab === 'details' ? 'black' : 'white',
                                color: activeTab === 'details' ? 'white' : 'black',
                                marginRight: '10px',
                            }}
                            onClick={() => setActiveTab('details')}
                        >
                            Order Details
                        </button>

                        <button
                            style={{
                                background: activeTab === 'tracking' ? 'black' : 'white',
                                color: activeTab === 'tracking' ? 'white' : 'black',
                                marginRight: '10px',
                            }}
                            onClick={() => setActiveTab('tracking')}
                        >
                            Order Tracking
                        </button>

                        <button
                            style={{
                                background: activeTab === 'payment_details' ? 'black' : 'white',
                                color: activeTab === 'payment_details' ? 'white' : 'black',
                            }}
                            onClick={() => setActiveTab('payment_details')}
                        >
                            Payment Details
                        </button>
                    </div>

                    {activeTab !== 'payment_details' && (
                        <>
                            {activeTab === 'details' && renderOrderDetails()}
                            {activeTab === 'tracking' && renderTrackingContentDEMO()}
                        </>
                    )}

                    <Row className="mt-3">
                        <Col md="6">
                            {renderCustomerDetails()}
                        </Col>
                        <Col md="6">
                            {renderOrderTotal()}
                        </Col>
                    </Row>

                    {orderData?.status === 'pending' && (
                        <>
                            <Row className="mt-3">
                                <div className="col-sm-12 text-center">
                                    <button className="btn btn-mat waves-effect waves-light btn-dark" onClick={(e) => processOrder(e, true)}>Process Order with Lalamove</button>
                                    <button className="btn btn-mat waves-effect waves-light btn-dark m-2" onClick={(e) => processOrder(e, false)}>Process Order without Lalamove</button>
                                </div>
                            </Row>
                        </>
                    )}

                    {orderData?.late_status === true && orderData?.lalamove_orderID && orderData?.status === 'confirmed' && (
                        <>
                            <Row className="mt-3">
                                <div className="col-sm-12 text-center">
                                    <button className="btn btn-mat waves-effect waves-light btn-dark" onClick={(e) => cancelLalamove(e)}>Cancel Lalamove Only</button>
                                </div>
                            </Row>
                        </>
                    )}

                    {orderData?.lalamove_canceStatus === true && (
                        <>
                            <Row className="mt-3">
                                <div className="col-sm-12 text-center">
                                    <button className="btn btn-mat waves-effect waves-light btn-dark" onClick={(e) => processOrder(e, true)}>Book Lalamove Only</button>
                                </div>

                                <div className="col-sm-3"></div>
                                <div className="col-sm-6 text-center mt-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <InputGroup>
                                        <Input
                                            placeholder="Lalamove ID"
                                            className="text-center"
                                            value={inputValueLink}
                                            onChange={handleInputLinkChange}
                                        />
                                        <InputGroupText addonType="append">
                                            <Button color="dark" onClick={applyLink}>Link Lalamove</Button>
                                        </InputGroupText>
                                    </InputGroup>
                                </div>
                                <div className="col-sm-3"></div>

                            </Row>
                        </>
                    )}

                </LoadingOverlay>
            </div>
        </div>
    );
};

export default OrderDetails;